const IsValidProperty = (prop) => {
    return (prop !== undefined && prop !== null && prop.length !== 0);
};

export default IsValidProperty;